import React from 'react';
import styles from './styles.module.css';

const LoaderVertical: React.FC = () => (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem' }}>
        <div className={styles.ldsEllipsis}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
);

export default LoaderVertical;
